import { PriceType } from "../Data";

export const BOOKS_SERVICE_URLS = {
    GET_BOOKS: 'books',
    GET_BOOK_BY_ID: 'books/'
};

// Параметри для отримання списку
export interface GetItemsRequestData {
    search: string | undefined;
    tags: number[] | undefined;
    authors: number[] | undefined;
    publishers: number[] | undefined;
    genres: number[] | undefined;
    series: number[] | undefined;
    onlyInStock: boolean | undefined;
    availability: GetItemsAvailabilityFilter | undefined;
    pageIndex: number;
    pageCount: number;
    sortBy: GetBookRequestSortByEnum | undefined;
    sortDescending: boolean | undefined;
}

export enum GetBookRequestSortByEnum {
    Name = 0,
    Rating = 1,
    Id = 2
}

export enum GetItemsAvailabilityFilter {
    All = 'All',
    InStock = 'InStock',
    OutOfStock = 'OutOfStock'
}

// Додаткові структури, які беруть участь у відповіді
export interface PublisherData {
    id: number;
    name: string;
    description: string | undefined;
}

export interface SeriesData {
    id: number;
    name: string;
}

export interface AuthorData {
    id: number;
    name: string;              // приклад: "М. Л. Ріо"
    lastName?: string;         // якщо не приходить з беку, можна лишити опційним
    biography?: string | null; // на бекенді буває null
    rank?: number | null;      // теж може бути null
}

export interface GenreData {
    id: number;
    name: string;
    description: string | undefined;
}

export interface TagData {
    id: number;
    name: string;
}

// Інтерфейс для "reviews", якщо детально невідомо, що всередині
// можна оголосити як масив довільних об'єктів або створити детальніший інтерфейс
export interface ReviewData {
    id: number;
    displayName: string;
    text: string;
    rating?: number | null;
    createdAt?: string;
    userId: number;
    userName?: string;
    userLastName?: string;
}

// Якщо "images" повертається масивом об'єктів, для яких детально нічого не відомо,
// можна оголосити окремий інтерфейс або використати any[].
export interface ImageData {
    id: number;
    name?: string;
    url?: string;
    thumbUrl?: string;
    mediumUrl?: string;
    originalUrl?: string;
    isPrimary?: boolean;
    sortOrder?: number;
    // За потреби можна додати поля (id, url тощо)
    // id: number;
    // url: string;
}

export enum GetBookRequestTypeEnum {
    Book = 0,
    Merchandise = 1
}

/**
 * Оновлений інтерфейс, що враховує всі поля з відповіді
 */
export interface BookResponseData {
    isbn: string | undefined;           // "978-617-523-138-8"
    pages: number | undefined;          // 400
    rating: number | undefined;         // 4.14
    internalRating: number | null;      // null
    series: SeriesData | null;          // { id, name }
    seriesNumber: number | null;
    publisher: PublisherData | null;    // { id, name, description ... }
    isLimitedEdition: boolean;          // true/false
    authors: AuthorData[];             // масив авторів
    genres: GenreData[];               // масив жанрів
    id: number;                         // 1
    name: string;                       // "Ніби ми злодії 1"
    description: string | undefined;    // великий опис
    type: GetBookRequestTypeEnum;       // 0 (Book), 1 (Merchandise)
    stockCount: number | undefined;     // 1
    price: number;                     // ціна
    priceType: PriceType;
    isDeleted: boolean;                 // false
    recommendedItems: BookResponseData[]; // масив рекомендованих книг (може бути пустим)
    reviews: ReviewData[];             // масив відгуків
    images: ImageData[];               // масив зображень
    primaryImage?: ImageData;
    tags: TagData[];
    image: string | undefined;
    isInWishList : boolean
    readerCount: number;
}
